import { render, staticRenderFns } from "./printGroup.vue?vue&type=template&id=23f90b54"
import script from "./printGroup.vue?vue&type=script&lang=js"
export * from "./printGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports